if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        if (this.form.querySelector("[name=id]")) {
          this.form.querySelector("[name=id]").disabled = false;
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
        this.enableSizeConfirmation =
          window.themeSettings?.enableSizeConfirmation || false;
        this.enablePreorderConfirmation =
          window.themeSettings?.enablePreorderConfirmation || false;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        const variantSizeInput = this.form.querySelector("[name=size-option]");
        const variantSize = variantSizeInput ? variantSizeInput.value : null;
        const size = variantSize;

        if (size === "2XS" && this.enableSizeConfirmation) {
          const cartData = await this.fetchCart();
          const isSizeInCart = this.checkSizeInCart(cartData, "2XS");

          if (!isSizeInCart) {
            const confirmSizePopUp = document.getElementById(
              "confirm-size-pop-up"
            );
            confirmSizePopUp.style.display = "flex";

            const confirmSizeYesButton =
              document.getElementById("confirm-size-yes");
            const confirmSizeNoButton =
              document.getElementById("confirm-size-no");

            confirmSizeYesButton.addEventListener(
              "click",
              () => {
                confirmSizePopUp.style.display = "none";
                this.handleFormSubmission(); // Trigger the form submission manually
              },
              { once: true }
            );

            confirmSizeNoButton.addEventListener(
              "click",
              () => {
                confirmSizePopUp.style.display = "none";
                this.submitButton.removeAttribute("aria-disabled");
                this.submitButton.classList.remove("loading");
                this.querySelector(".loading-overlay__spinner").classList.add(
                  "hidden"
                );
                return;
              },
              { once: true }
            );
          } else {
            this.handleFormSubmission(); // Trigger the form submission for other sizes
          }
        } else if (this.enablePreorderConfirmation) {
          const hasPreorderBadge = this.checkPreorderBadge();

          if (hasPreorderBadge) {
            this.handleFormSubmission();
          } else if (
            this.form.querySelector("#preorder_consolidated")?.name ===
              "properties[Pre-order]" ||
            this.form.querySelector("#us_preorder_consolidated")?.name ===
              "properties[Pre-order]"
          ) {
            const confirmPreOrderPopUp =
              document.getElementById("confirm-preorder");
            confirmPreOrderPopUp.style.display = "flex";

            const confirmPreOrderYesButton = document.getElementById(
              "confirm-preorder-yes"
            );
            const confirmPreOrderNoButton = document.getElementById(
              "confirm-preorder-no"
            );

            confirmPreOrderYesButton.addEventListener(
              "click",
              () => {
                confirmPreOrderPopUp.style.display = "none";
                this.handleFormSubmission(); // Trigger the form submission manually
              },
              { once: true }
            );

            confirmPreOrderNoButton.addEventListener(
              "click",
              () => {
                confirmPreOrderPopUp.style.display = "none";
                this.submitButton.removeAttribute("aria-disabled");
                this.submitButton.classList.remove("loading");
                this.querySelector(".loading-overlay__spinner").classList.add(
                  "hidden"
                );
                return;
              },
              { once: true }
            );
          } else {
            this.handleFormSubmission(); // Trigger the form submission for other cases
          }
        } else {
          this.handleFormSubmission(); // Trigger the form submission for other cases
        }
      }

      async fetchCart() {
        try {
          const response = await fetch("/cart.js", {
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          });
          return await response.json();
        } catch (error) {
          console.error("Failed to fetch cart data:", error);
          return null;
        }
      }

      checkSizeInCart(cartData, size) {
        if (!cartData || !cartData.items) return false;
        for (const item of cartData.items) {
          if (item.options_with_values) {
            for (const option of item.options_with_values) {
              if (option.name === "Size" && option.value === size) {
                return true;
              }
            }
          }
        }
        return false;
      }

      checkPreorderBadge() {
        const cartItems = document.querySelectorAll(".cart-item");
        for (const item of cartItems) {
          const productOptions = item.querySelectorAll(".product-option");
          for (const option of productOptions) {
            const dt = option.querySelector("dt");
            if (dt && dt.textContent.trim() === "Pre-order:") {
              const dd = dt.nextElementSibling;
              if (dd && dd.textContent.trim()) {
                return true;
              }
            }
          }
        }
        return false;
      }

      handleFormSubmission() {
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })

          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            this.showAddToCartSuccessMessage();

            document.dispatchEvent(
              new CustomEvent("cart:addtocart_complete", {
                detail: { cart: this.cart },
              })
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      showAddToCartSuccessMessage() {
        const successMessage = this.submitButton.querySelector(
          ".add-to-cart-success-message"
        );
        const addToCartText =
          this.submitButton.querySelector(".add-to-cart-text");

        if (successMessage && addToCartText) {
          addToCartText.classList.add("hidden");
          successMessage.classList.remove("hidden");
          setTimeout(() => {
            successMessage.classList.add("hidden");
            addToCartText.classList.remove("hidden");
          }, 3000);
        }
      }
    }
  );
}
